import AppHomeTile from '../app-home-tile'
import CoreFetch from '../core-fetch'

export default
{
    components:
    {
        AppHomeTile,
        CoreFetch
    },

    props:
    {
        content: { type: Array, default: null },
        loop: { type: Boolean, default: true },
        hasSocialTiles: { type: Boolean, default: true },
        hasFakeScroll: { type: Boolean, default: true }
    },

    data()
    {
        return {
            contentLeft: [],
            contentMiddle: [],
            contentRight: [],

            dataSrc: '',

            isReady: false,
            isEmpty: false,

            colsLeftHeight: 0,
            colsMiddleHeight: 0,
            colsRightHeight: 0,

            activeColumnIndex: -1,

            spinnerColor: '',

            imageMagmaEmpty: '',

            hasScroll: true
        }
    },

    created()
    {
        this._isFiltering = false

        this._isLooping = false

        this._scrollAuto = [0,0,0]
        this._currScrollY = [0,0,0]

        this._hasMobileLoop = false

        this.eventHub.$on('window:resize', this.onResize)
        this.eventHub.$on('window:tick', this.onTick)

        this.eventHub.$on('home:filter', this.onFilterTiles)

        this.eventHub.$emit('set:magmaContent', this.content)
    },

    mounted()
    {
        this.$cols = this.$el.querySelectorAll('.js-col')
        this.$colsContainer = this.$el.querySelectorAll('.js-col-container')

        if(this.$root.globalContent.settings.image_magma)
        {
            this.imageMagmaEmpty = this.$root.globalContent.settings.image_magma[this.getRandomInt(0, this.$root.globalContent.settings.image_magma.length)].sizes.large
        }

        this.dispatchContent(this.content)

        this.isEmpty = this.content.length === 0

        this.onResize()

        setTimeout(() =>
        {
            this.$emit('page:ready')
        }, 500)
    },

    destroyed()
    {
        this.eventHub.$off('window:resize', this.onResize)
        this.eventHub.$off('window:tick', this.onTick)
    },

    methods:
    {
        dispatchContent(content)
        {
            this.contentLeft = []
            this.contentMiddle = []
            this.contentRight = []

            this.$nextTick(() =>
            {
                const thirdContentLength = content.length / 3
                const halfContentLength = content.length / 2

                for(let i = 0; i < content.length; i++)
                {
                    if(!this.$root.isSmallScreen)
                    {
                        if(!this.$root.isMagmaFiltered)
                        {
                            if((!content[i].featured && content[i].post_type !== 'team') || this.$root.currentPath !== 'home')
                            {
                                // dispatch content in three columns
                                if(i < thirdContentLength)
                                {
                                    this.contentMiddle.push(content[i])
                                }
                                else if(i >= thirdContentLength && i < thirdContentLength * 2)
                                {
                                    this.contentLeft.push(content[i])
                                }
                                else
                                {
                                    this.contentRight.push(content[i])
                                }
                            }
                        }
                        else
                        {
                            // dispatch content in three columns
                            if(i < thirdContentLength)
                            {
                                this.contentMiddle.push(content[i])
                            }
                            else if(i >= thirdContentLength && i < thirdContentLength * 2)
                            {
                                this.contentLeft.push(content[i])
                            }
                            else
                            {
                                this.contentRight.push(content[i])
                            }
                        }
                    }
                    else
                    {
                        if(!this.$root.isMagmaFiltered)
                        {
                            if((!content[i].featured && content[i].post_type !== 'team') || this.$root.currentPath !== 'home')
                            {
                                // dispatch content in two columns
                                if(i < halfContentLength)
                                {
                                    this.contentLeft.push(content[i])
                                }
                                else
                                {
                                    this.contentMiddle.push(content[i])
                                }
                            }
                        }
                        else
                        {
                            // dispatch content in two columns
                            if(i < halfContentLength)
                            {
                                this.contentLeft.push(content[i])
                            }
                            else
                            {
                                this.contentMiddle.push(content[i])
                            }
                        }
                    }
                }

                for(let i = 0; i < content.length; i++)
                {
                    if(content[i].featured)
                    {
                        console.log('featured')
                    }

                    if(!this.$root.isSmallScreen)
                    {
                        // dispatch featured content on top
                        if(content[i].featured && this.$root.currentPath === 'home' && !this.$root.isMagmaFiltered)
                        {
                            const rand = Math.random()

                            if(rand <= 0.33)
                            {
                                this.contentLeft.splice(this.getRandomInt(0, 4), 0, content[i])
                            }
                            else if(rand > 0.33 && rand <= 0.66)
                            {
                                this.contentMiddle.splice(this.getRandomInt(0, 4), 0, content[i])
                            }
                            else
                            {
                                this.contentRight.splice(this.getRandomInt(0, 4), 0, content[i])
                            }
                        }

                        if(content[i].post_type === 'team' && !content[i].featured && !this.$root.isMagmaFiltered)
                        {
                            const rand = Math.random()

                            if(rand <= 0.33)
                            {
                                this.contentLeft.splice(this.getRandomInt(4, this.contentLeft.length), 0, content[i])
                            }
                            else if(rand > 0.33 && rand <= 0.66)
                            {
                                this.contentMiddle.splice(this.getRandomInt(4, this.contentMiddle.length), 0, content[i])
                            }
                            else
                            {
                                this.contentRight.splice(this.getRandomInt(4, this.contentRight.length), 0, content[i])
                            }
                        }
                    }
                    else
                    {
                        // dispatch featured content on top
                        if(content[i].featured && this.$root.currentPath === 'home' && !this.$root.isMagmaFiltered)
                        {
                            const rand = Math.random()

                            if(rand <= 0.5)
                            {
                                this.contentLeft.splice(this.getRandomInt(0, 4), 0, content[i])
                            }
                            else
                            {
                                this.contentMiddle.splice(this.getRandomInt(0, 4), 0, content[i])
                            }
                        }

                        if(content[i].post_type === 'team' && !content[i].featured && !this.$root.isMagmaFiltered)
                        {
                            const rand = Math.random()

                            if(rand <= 0.5)
                            {
                                this.contentLeft.splice(this.getRandomInt(3, this.contentLeft.length), 0, content[i])
                            }
                            else
                            {
                                this.contentMiddle.splice(this.getRandomInt(3, this.contentMiddle.length), 0, content[i])
                            }
                        }
                    }
                }


                this.addRandomLayoutToTiles(this.contentLeft, 0)
                this.addRandomLayoutToTiles(this.contentMiddle, 1)
                this.addRandomLayoutToTiles(this.contentRight, 2)

                if(this.hasSocialTiles && !this.$root.isMagmaFiltered)
                {
                    // add randomly social links tiles to columns
                    this.getRandomContent().splice(this.getRandomInt(0, this.getRandomContent().length), 0, {'post_type': 'twitter-link', 'layout': 'small'})
                    this.getRandomContent().splice(this.getRandomInt(0, this.getRandomContent().length), 0, {'post_type': 'instagram-link', 'layout': 'small'})
                    this.getRandomContent().splice(this.getRandomInt(0, this.getRandomContent().length), 0, {'post_type': 'facebook-link', 'layout': 'small'})
                }

                this._baseLeft = this.contentLeft
                this._baseMiddle = this.contentMiddle
                this._baseRight = this.contentRight
            })

            setTimeout(() =>
            {
                this.onResize()

                this.$nextTick(() =>
                {
                    this.isReady = true
                })
            }, 1000)
        },

        addRandomLayoutToTiles(content, columnPos)
        {
            const layouts = ['normal', 'small']
            const layoutsWtSmall = ['normal']


            if(columnPos === 1)
            {
                let isSmall = false

                for(let i = 0; i < content.length; i++)
                {
                    // if there is a small tile, next tile must be a small tile too
                    if(i > 0 && content[i - 1].layout === 'small' && !isSmall)
                    {
                        isSmall = true
                        this.$set(content[i], 'layout', 'small-right')
                    }
                    else
                    {
                        let randomLayout = 0

                        if(i === content.length - 1)
                        {
                            // give random layout to each tile expect small if it's last tile
                            randomLayout = layoutsWtSmall[this.getRandomInt(0, layoutsWtSmall.length)]
                        }
                        else if(i < content.length - 1 && content[i].post_type !== 'team')
                        {
                            randomLayout = layouts[this.getRandomInt(0, layouts.length)]
                        }
                        else if(i < content.length - 1 && content[i].post_type === 'team')
                        {
                            randomLayout = 'small'
                        }

                        isSmall = false
                        this.$set(content[i], 'layout', randomLayout)
                    }
                }
            }
            else
            {
                let isSmall = false

                for(let i = 0; i < content.length; i++)
                {
                    let randomLayout = 0

                    // if there is a small tile, next tile must NOT be a small tile too
                    if(i > 0 && content[i - 1].layout === 'small' && !isSmall)
                    {
                        isSmall = true
                        randomLayout = layoutsWtSmall[this.getRandomInt(0, layoutsWtSmall.length)]
                    }
                    else
                    {
                        randomLayout = layouts[this.getRandomInt(0, layouts.length)]
                    }

                    isSmall = false

                    this.$set(content[i], 'layout', randomLayout)
                }
            }

        },

        onFilterTiles(dataSrc, cat)
        {
            if(this.$root.currentPath !== 'home')
            {
                return
            }

            clearTimeout(this._dataSrcTimer)

            this.$el.classList.add('is-filtering')

            window.scrollTo(0, 0)
            document.body.classList.add('u-overflow-h')

            if(this.$root.isTouch)
            {
                this.eventHub.$emit('disable:touch')
            }

            clearTimeout(this._timerIn)
            clearTimeout(this._timerOut)
            clearTimeout(this._timerOverflow)

            this._isFiltering = true

            if(cat === 'projects')
            {
                this.spinnerColor = this.$root.color[0]
            }
            else if(cat === 'article')
            {
                this.spinnerColor = this.$root.color[1]
            }
            else if(cat === 'medias')
            {
                this.spinnerColor = this.$root.color[2]
            }
            else if(cat === 'team')
            {
                this.spinnerColor = this.$root.color[3]
            }

            this.isReady = false
            this._scrollAuto = [0,0,0]
            this.eventHub.$emit('destroy:virtualScroll')


            this._dataSrcTimer = setTimeout(() =>
            {
                this.dataSrc = ''

                this.$nextTick(() =>
                {
                    this.dataSrc = dataSrc
                })
            }, 500)
        },

        onResetFilters()
        {
            this.eventHub.$emit('filters:reset')
        },

        onDataLoaded(resp)
        {
            if(resp.length === 0)
            {
                this.isEmpty = true
            }
            else
            {
                this.isEmpty = false
            }

            this.dispatchContent(resp)
            this.onResize()

            this.eventHub.$emit('set:magmaContent', resp)

            this._timerIn = setTimeout(() =>
            {
                this.eventHub.$emit('set:virtualScroll')
            }, 50)

            this._timerOut = setTimeout(() =>
            {
                this._isFiltering = false
                this.$el.classList.remove('is-filtering')
            }, 100)


            // ugly
            this._timerOverflow = setTimeout(() =>
            {
                document.body.classList.remove('u-overflow-h')

                if(this.$root.isTouch)
                {
                    this.eventHub.$emit('enable:touch')
                }
            }, 1000)
        },

        onResize()
        {
            this.colsLeftHeight = this.$cols[0].offsetHeight
            this.colsMiddleHeight = this.$cols[1].offsetHeight
            this.colsRightHeight = this.$cols[2].offsetHeight

            this._colsLeftOffset = (this.$root.window.height / 10) * 3
            this._colsMiddleOffset = (this.$root.window.height / 10) * 2
            this._colsRightOffset = (this.$root.window.height / 10) * 3

            if(this.colsLeftHeight > this.$root.window.height && this.colsMiddleHeight > this.$root.window.height)
            {
                this._hasMobileLoop = true
            }
            else
            {
                this._hasMobileLoop = false
            }

            if(this.colsLeftHeight + this._colsLeftOffset < this.$root.window.height && this.colsMiddleHeight + this._colsMiddleOffset < this.$root.window.height && this.colsRightHeight + this._colsRightOffset < this.$root.window.height)
            {
                this.hasScroll = false
                this.eventHub.$emit('destroy:virtualScroll')
            }
            else
            {
                this.hasScroll = true
                this.eventHub.$emit('set:virtualScroll')
            }
        },

        onCartoucheEnter(columnIndex)
        {
            this.activeColumnIndex = columnIndex
        },

        onCartoucheLeave(columnIndex)
        {
            this.activeColumnIndex = -1
        },

        onLoop()
        {
            this.contentLeft.push.apply(this._baseLeft, this.contentLeft)
            this.contentMiddle.push.apply(this._baseMiddle, this.contentMiddle)
            this.contentRight.push.apply(this._baseRight, this.contentRight)

            setTimeout(() =>
            {
                this._isLooping = false
            }, 50)
        },

        onTick()
        {
            if(this.$root.isTouch && this.isReady && this._hasMobileLoop && this.$root.currentPath === 'home')
            {
                for(let i = 0; i < this.$cols.length; i++)
                {
                    if(!this._isLooping && this.$cols[i].offsetHeight > 0 && this.$root.scrollTop >= this.$cols[i].offsetHeight - this.$root.window.height)
                    {
                        this._isLooping = true
                        this.onLoop()
                    }
                }
                this.$cols[1].style.transform = 'translateY(' + this.$root.scrollTop * 0.2 + 'px) translateZ(0)'
            }
        },

        getRandomContent()
        {
            return Math.random() >= 0.5 ? this.contentLeft : this.contentRight
        },

        getRandomInt(min, max, exept)
        {
            const rand = Math.floor(Math.random() * max) + min
            return rand === exept ? this.getRandomInt(min, max, exept) : rand
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-magma/script.js